import React from 'react';
import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { FaPhone, FaEnvelope, FaHome } from 'react-icons/fa';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setFormData({
      name: '',
      email: '',
      subject: '',
      message: ''
    });
    
    setTimeout(() => {
      setSubmitted(false);
    }, 5000);
  };

  return (
    <div className="contact-container">
      <Helmet>
        <title>Contact Us - Fitness Health Blog</title>
        <meta name="description" content="Get in touch with Fitness Health Blog. We are here to help with your fitness and wellness questions." />
        <meta property="og:title" content="Contact Fitness Health Blog" />
        <meta property="og:description" content="Contact our team for any questions about our fitness and health products" />
      </Helmet>

      <h1>Contact Us</h1>

      <div className="contact-grid">
        <div className="contact-info">
          <h2>Get In Touch</h2>
          <p>
            We would love to hear from you! Whether you have questions about our products, need assistance with 
            an order, or want to learn more about fitness and wellness, our team is here to help.
          </p>

          <div className="contact-item">
            <div className="contact-item-icon"><FaHome /></div>
            <div className="contact-item-text">
              <h3>Our Address</h3>
              <p>Studio 52 Kennedy Grove South Wendy</p>
              <p>NW2 2SH, United Kingdom</p>
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-item-icon"><FaPhone /></div>
            <div className="contact-item-text">
              <h3>Phone Number</h3>
              <p>+448648285526</p>
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-item-icon"><FaEnvelope /></div>
            <div className="contact-item-text">
              <h3>Email Address</h3>
              <p>info@topfitnessproducts.com</p>
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-item-text">
              <h3>Business Information</h3>
              <p>Company Registration Number: 27135609</p>
              <p>Registered in United Kingdom</p>
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-item-text">
              <h3>Business Hours</h3>
              <p>Monday - Friday: 9:00 AM - 6:00 PM</p>
              <p>Saturday: 10:00 AM - 4:00 PM</p>
              <p>Sunday: Closed</p>
            </div>
          </div>
        </div>

        <div className="contact-form">
          <h2>Send Us a Message</h2>
          
          {submitted && (
            <div style={{
              padding: '1rem',
              background: 'linear-gradient(135deg, #10ac84 0%, #05c46b 100%)',
              color: 'white',
              borderRadius: '10px',
              marginBottom: '1rem',
              textAlign: 'center'
            }}>
              Thank you for your message! We will get back to you soon.
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Your Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="subject">Subject</label>
              <input
                type="text"
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="5"
                required
              ></textarea>
            </div>

            <button type="submit" className="submit-button">
              Send Message
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Contact;